import { IHasOptionalChildren } from '@/lib/interface';
import { LucideIcon } from 'lucide-react';
import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type TProps = IHasOptionalChildren & {
  description?: ReactNode;
  iconClassName?: string;
  className?: string;
  icon?: LucideIcon;
  title: string;
}

const PanelInfo = ({ children, title, description, className, iconClassName, ...props }: TProps) => (
  <div className={cn(
    `flex h-full w-full shrink-0 items-center justify-center rounded-md border border-dashed`,
    'animate__animated animate__fadeIn',
    className
  )}>
    <div className='mx-auto flex flex-col items-center justify-center text-center'>
      {
        props.icon &&
        <props.icon size={24} className={cn('h-10 w-10 text-muted-foreground', iconClassName)} />
      }
      {
        title &&
        <h3 className='mt-4 text-lg font-semibold'>
          {title}
        </h3>
      }
      {
        description &&
        <div className='mb-4 mt-2 text-sm text-muted-foreground'>
          {description}
        </div>
      }
      {children}
    </div>
  </div>
);

export default PanelInfo;
